// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
	production: false, //Para el ambiente pruebas
	API_URL: 'https://qaapi.league-sports.com/admin/v2/index.php/',
    //API_URL: 'https://api.league-sports.com/admin/v2/index.php/',
	API_KEY: '709c0111f0b6dc4d91a19ca192a10b44',

	ID_PP: '',
	CLUBNAME: 'LEAGUE SPORTS',
	DROPBOX_ACCESSTOKEN: '',
	TEMPOCONSULTA: 20000,
	BASE_PATH: 'http://localhost:4200/#/',
	VERSION: "1.0.0",
	APPSTORELINK: "",
	GOOGLEPLAYLINK: "",

	FIREBASE_CONFIG:{
		apiKey: "AIzaSyCexVdi4NxWzbjZjE-QQV6WR5eIGZEE5d8",
		authDomain: "league-sports-mobile-qa.firebaseapp.com",
		projectId: "league-sports-mobile-qa",
		storageBucket: "league-sports-mobile-qa.firebasestorage.app",
		messagingSenderId: "953665147754",
		appId: "1:953665147754:web:e87ecc909edd5e61334b13",
		measurementId: "G-QZS99WG1HY"
	}

};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
